import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ExpenseType } from '../state-man/models/expense-type.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class ExpenseTypeService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  public async getAll () : Promise<ExpenseType[] | null> {      
    try {
      const ret = await this.apiService.apiReturnsAny('get', 'expense_type/active/')           
      return (ret && Array.isArray(ret)) ? ExpenseType.buildMany(ret) : null
    } 
    catch (error) {    
      LoggerService.log(error + 'expense_type/active/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')      
      return null
    }
  }  
  
}
